/* Use the installed Boost engine and shop configuration with the relaunch card UI. */
var boostPFSFilterConfig={general:{limit:30,loadProductFirst:true,capitalizeFilterOptionValues:false,paginationType:'infinite'},label:{loadMore:'Mehr Schmuckstücke anzeigen'},selector:{products:'.boost-pfs-filter-products'}};
(function(){
 if(!window.BoostPFS)return;
 BoostPFS.inject(this);
 const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

 function gsrProductLabel(p){
  const tags=Array.isArray(p.tags)?p.tags.map(t=>String(t).toLowerCase()):[],cols=p.collections||[];
  const best=(window.gsrAutomaticBestsellerIds||[]).includes(String(p.id))||tags.includes('bestseller')||cols.some(c=>c.handle==='unsere-beststeller'||String(c.title||'').toLowerCase().includes('bestseller'));
  const isNew=tags.includes('new in')||cols.some(c=>c.handle==='new-in'||String(c.title||'').toLowerCase().includes('new in'));
  const label=best?'Bestseller':isNew?'New in':tags.some(t=>t==='influencerchoice'||t==='influencer choice')?'Influencer Choice':'';
  return label?'<div class="gsr-product-labels"><span class="gsr-product-tag">'+esc(label)+'</span></div>':'';
 }
 ProductGridItem.prototype.compileTemplate=function(data){
  const p=data||this.data;
  const photo=p.images_info?.[0]?.src||p.images?.[0]||'';
  const img=typeof photo==='string'?photo:'';
  const price=Number(p.price_min),compare=Number(p.compare_at_price_min),sale=compare>price;
  const material=(p.metafields||[]).find(m=>(m.namespace||'').toLowerCase()==='basismaterial'&&(m.key||'').toLowerCase()==='basismaterial')?.value||'';
  const href=Utils.buildProductItemUrl(p,false);
  return `<article class="product-card catalog-card gs-product-card collection__page-product product-index" data-id="${esc(p.id)}" data-product-id="${esc(p.id)}" id="product-listing-${esc(p.id)}"><a class="gs-product-link" href="${esc(href)}"><div class="product-photo"><img src="${esc(Utils.optimizeImage(img,'700x'))}" alt="${esc(p.title)}" width="700" height="700" loading="lazy">${sale?`<span class="gs-sale-label">−${Math.round((1-price/compare)*100)}%</span>`:''}</div>${gsrProductLabel(p)}${material?`<p class="gs-material">${esc(material)}</p>`:''}<h3>${esc(p.title)}</h3><p class="product-price"><span>${Utils.formatMoney(price,Globals.moneyFormat)}</span>${sale?`<del>${Utils.formatMoney(compare,Globals.moneyFormat)}</del>`:''}</p></a><div class="starapps-product-swatches" data-product-handle="${esc(p.handle)}"></div></article>`;
 };
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;

    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage !== 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return '';
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Object.assign({}, Utils.getSortingList() || {});
      var activeSort = String(Globals.queryParams.sort || Globals.defaultSorting || 'manual');
      var sortLabels = {'manual':'Empfohlen','most-relevant':'Relevanz','relevance':'Relevanz','best-selling':'Bestseller','title-ascending':'Alphabetisch A–Z','title-descending':'Alphabetisch Z–A','price-ascending':'Preis aufsteigend','price-descending':'Preis absteigend','created-ascending':'Älteste zuerst','created-descending':'Neueste zuerst'};
      if (!Object.prototype.hasOwnProperty.call(sortingArr, activeSort)) sortingArr[activeSort] = sortLabels[activeSort] || 'Empfohlen';
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          sortingItemsHtml += '<option value="' + esc(k) + '"' + (k === activeSort ? ' selected' : '') + '>' + esc(sortingArr[k]) + '</option>';
        }
        var html = '<label class="gsr-sort-label">Sortieren<select id="boost-select" aria-label="Sortieren" class="styled-select">'+sortingItemsHtml+'</select></label>';
      }
    }
    return html;
  };


 ProductList.prototype.afterRender=function(){
  document.documentElement.classList.add('gsr-boost-ready');
  document.dispatchEvent(new CustomEvent('gsr:products-rendered'));
 };
 Filter.prototype.afterRender=function(data){
  requestAnimationFrame(()=>document.querySelectorAll('.boost-pfs-filter-option-title-text').forEach(e=>{for(const n of e.childNodes)if(n.nodeType===3&&n.textContent.trim()==='MOTIV')n.textContent='Motiv';}));
  const d=data||this.data||{};
  const count=document.querySelector('.boost-pfs-filter-total-products');
  if(count&&d.total_product!==undefined)count.textContent=d.total_product+' Schmuckstücke';
  document.documentElement.classList.add('gsr-boost-ready');
 };
})();

/* Theme-local presentation layer. Product metafields and Boost app settings are unchanged. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.BoostPFS && root.FilterApi) api.install(root);
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  const IDS = ['pf_m_::Kettenlaenge::Kettenlaenge', 'pf_m_::Armbandlaenge::Armbandlaenge'];
  const target = id => IDS.includes(id);
  const num = s => Number(s.replace(',', '.'));
  const fmt = n => String(Math.round(n * 100) / 100).replace('.', ',');
  const n = '(\\d+(?:[.,]\\d+)?)';
  const plus = new RegExp('^' + n + '\\s*cm(?:\\s+(?:Basiskette|Basislänge|Kettenlänge))?\\s*\\+\\s*' + n + '\\s*cm(?:\\s+Verl\\S*)?$', 'i');
  const range = new RegExp('^' + n + '\\s*[-–—]\\s*' + n + '\\s*cm(?:,?\\s*(?:flexibel|stufenlos)\\s+einstellbar)?$', 'i');
  const fixed = new RegExp('^' + n + '\\s*cm$', 'i');
  const flex = new RegExp('^' + n + '\\s*cm,?\\s*flexibel\\s+einstellbar$', 'i');
  const multiple = new RegExp('^' + n + '\\s*/\\s*' + n + '\\s*cm(?:\\s+Basiskette)?\\s*\\+\\s*' + n + '\\s*cm(?:\\s+Verl\\S*)?$', 'i');
  function normalize(value) {
    const raw = String(value ?? '').replace(/\u00a0/g, ' ').trim().replace(/\s+/g, ' ');
    let m;
    if ((m = raw.match(plus))) {
      const lo = num(m[1]), hi = Math.round((lo + num(m[2])) * 100) / 100;
      return { key: `range:${lo}:${hi}`, label: `${fmt(lo)}–${fmt(hi)} cm`, lo, hi, rank: 1 };
    }
    if ((m = raw.match(range)) && num(m[1]) <= num(m[2])) {
      const lo = num(m[1]), hi = num(m[2]);
      return { key: `range:${lo}:${hi}`, label: `${fmt(lo)}–${fmt(hi)} cm`, lo, hi, rank: 1 };
    }
    if ((m = raw.match(fixed))) {
      const lo = num(m[1]);
      return { key: `fixed:${lo}`, label: `${fmt(lo)} cm`, lo, hi: lo, rank: 0 };
    }
    if ((m = raw.match(flex))) {
      const lo = num(m[1]);
      return { key: `flex:${lo}`, label: `${fmt(lo)} cm · verstellbar`, lo, hi: lo, rank: 2 };
    }
    // Keep two separate chain lengths separate: do not invent one continuous range.
    if ((m = raw.match(multiple))) {
      return { key: 'raw:' + raw, label: `${fmt(num(m[1]))} / ${fmt(num(m[2]))} cm + ${fmt(num(m[3]))} cm`, lo: Infinity, hi: Infinity, rank: 3 };
    }
    if (/^flexibel einstellbar$/i.test(raw)) {
      return { key: 'flex:unknown', label: 'Flexibel einstellbar', lo: Infinity, hi: Infinity, rank: 4 };
    }
    return { key: 'raw:' + raw, label: raw, lo: Infinity, hi: Infinity, rank: 5 };
  }
  const compare = (a, b) => {
    const x = normalize(a.key), y = normalize(b.key);
    return (x.lo - y.lo) || (x.hi - y.hi) || (x.rank - y.rank) || x.label.localeCompare(y.label, 'de', { numeric: true });
  };
  function createRegistry() {
    const facets = new Map();
    const get = id => { if (!facets.has(id)) facets.set(id, new Map()); return facets.get(id); };
    function group(id, values) {
      const registry = get(id), visible = new Map();
      for (const row of values) {
        const info = normalize(row.key);
        if (!registry.has(info.key)) registry.set(info.key, { ...info, representative: row.key, members: new Set() });
        const known = registry.get(info.key);
        known.members.add(row.key);
        if (!visible.has(info.key)) visible.set(info.key, { ...row, key: known.representative, doc_count: 0 });
        visible.get(info.key).doc_count += Number(row.doc_count) || 0;
      }
      return [...visible.values()].sort(compare);
    }
    function expand(id, values) {
      const registry = get(id), out = new Set();
      for (const value of Array.isArray(values) ? values : values == null ? [] : [values]) {
        const known = registry.get(normalize(value).key);
        for (const raw of known ? known.members : [value]) out.add(raw);
      }
      return [...out];
    }
    return { facets, group, expand };
  }
  function install(w) {
    if (w.gsrLengthFilters || !w.Filter || !w.FilterOptionItem) return;
    const registry = createRegistry();
    const api = w.FilterApi, globals = w.Globals;
    const baseSetParam = api.setParam;
    const baseModify = w.Filter.prototype.modifyData;
    const baseSort = w.FilterOption.prototype.sortValues;
    const baseLabel = w.FilterOptionItem.prototype.buildLabel;
    const baseApplied = w.FilterOptionItem.prototype.isAppliedFilter;
    const baseApply = w.FilterOptionItem.prototype.onApplyFilter;
    const baseRefine = w.FilterRefineBy.prototype.setData;
    const baseClear = w.FilterClearButton.prototype.onClearSingleValue;
    const baseRender = w.FilterOption.prototype.render;
    const same = (a, b) => a.length === b.length && a.every(v => b.includes(v));
    let canonicalizationQueued = false;
    api.setParam = function (id, values) {
      return baseSetParam.call(this, id, target(id) && Array.isArray(values) ? registry.expand(id, values) : values);
    };
    w.Filter.prototype.modifyData = function (input) {
      const data = baseModify.call(this, input) || input;
      for (const option of data?.filter?.options || []) {
        if (!target(option.filterOptionId) || !Array.isArray(option.values)) continue;
        option.values = registry.group(option.filterOptionId, option.values);
        option.useAndCondition = false;
      }
      // Old links may select only one spelling. Canonicalize them to the complete group.
      if (!canonicalizationQueued) {
        const pending = IDS.map(id => {
          const current = globals.queryParams[id];
          if (!Array.isArray(current)) return null;
          const expanded = registry.expand(id, current);
          return same(current, expanded) ? null : { id, current: [...current], expanded };
        }).filter(Boolean);
        if (pending.length) {
          canonicalizationQueued = true;
          queueMicrotask(() => {
            canonicalizationQueued = false;
            let changed = false;
            for (const p of pending) {
              if (!same(globals.queryParams[p.id] || [], p.current)) continue;
              baseSetParam.call(api, p.id, p.expanded); changed = true;
            }
            if (changed) { baseSetParam.call(api, 'page', 1); api.applyFilter('filter'); }
          });
        }
      }
      return data;
    };
    w.FilterOption.prototype.sortValues = function (values) {
      if (target(this.filterOptionId)) return values.sort(compare);
      return baseSort.apply(this, arguments);
    };
    w.FilterOptionItem.prototype.buildLabel = function () {
      const option = this.filterOption || this.parent;
      if (target(option?.filterOptionId)) return w.Utils.stripHtml(normalize(this.value ?? this.label).label);
      return baseLabel.apply(this, arguments);
    };
    w.FilterOptionItem.prototype.isAppliedFilter = function () {
      if (!target(this.parent?.filterOptionId)) return baseApplied.apply(this, arguments);
      const selected = globals.queryParams[this.parent.filterOptionId];
      return Array.isArray(selected) && selected.some(value => normalize(value).key === normalize(this.value).key);
    };
    function setSelection(id, values, eventType) {
      globals.internalClick = true;
      api.setParam(id, values);
      api.setParam(id + '_and_condition', null);
      api.setParam('page', 1);
      api.applyFilter(eventType, { filterOptionId: id, filterOptionValue: values });
    }
    w.FilterOptionItem.prototype.onApplyFilter = function () {
      const id = this.parent?.filterOptionId;
      if (!target(id)) return baseApply.apply(this, arguments);
      const old = Array.isArray(globals.queryParams[id]) ? globals.queryParams[id] : [];
      const key = normalize(this.value).key;
      const next = this.isSelected ? old.filter(raw => normalize(raw).key !== key) : [...old, this.value];
      setSelection(id, next, 'filter');
    };
    w.FilterRefineBy.prototype.setData = function () {
      baseRefine.apply(this, arguments);
      const seen = new Set(), discarded = new Set();
      this.refineByItems = (this.refineByItems || []).filter(item => {
        if (!target(item.filterOptionId)) return true;
        const key = item.filterOptionId + '|' + normalize(item.filterItemId).key;
        if (seen.has(key)) { discarded.add(item); return false; }
        seen.add(key); return true;
      });
      if (Array.isArray(this.children)) this.children = this.children.filter(item => !discarded.has(item));
    };
    w.FilterClearButton.prototype.onClearSingleValue = function () {
      const id = this.parent?.filterOptionId;
      if (!target(id)) return baseClear.apply(this, arguments);
      const key = normalize(this.parent.filterItemId).key;
      const selected = Array.isArray(globals.queryParams[id]) ? globals.queryParams[id] : [];
      setSelection(id, selected.filter(raw => normalize(raw).key !== key), 'clear');
    };
    w.FilterOption.prototype.render = function () {
      baseRender.apply(this, arguments);
      if (!target(this.filterOptionId)) return;
      const el = this.$element?.[0], content = this.$filterOptionContentElement?.[0];
      if (!el || !content) return;
      el.classList.add('gsr-length-filter');
      if (!content.querySelector('.gsr-length-help')) {
        const note = w.document.createElement('p');
        note.className = 'gsr-length-help';
        note.textContent = 'Längenbereiche inklusive Verlängerung.';
        content.insertBefore(note, content.firstChild);
      }
    };
    w.gsrLengthFilters = { normalize, registry, ids: IDS };
  }
  return { normalize, compare, createRegistry, install, ids: IDS };
});
